module.exports = __webpack_public_path__ + "img/group.903409f1.svg";